import { render } from "./HomePartners.vue?vue&type=template&id=18307fb5&scoped=true"
import script from "./HomePartners.vue?vue&type=script&lang=js"
export * from "./HomePartners.vue?vue&type=script&lang=js"

import "./HomePartners.vue?vue&type=style&index=0&id=18307fb5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18307fb5"]])

export default __exports__